import { SET_PERSON, SET_PERSONS } from "../../constants/personConstants";

const initialState = {
  person: null,
  allPerson: [],
  customers: [],
  personnel: [],
  sellers: [],
  providers: [],
  filteredPersons: [],
};

const personReducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_PERSON:
      return {
        ...state,
        person: action.person,
      };
    case SET_PERSONS:
      if (action.personType === "customer") {
        return { ...state, customers: action.persons };
      } else if (action.personType === "personnel") {
        return { ...state, personnel: action.persons };
      } else if (action.personType === "seller") {
        return { ...state, sellers: action.persons };
      } else if (action.personType === "provider") {
        return { ...state, providers: action.persons };
      }
      return { ...state, allPerson: action.persons };
    default:
      return state;
  }
};

export default personReducer;
